import { ApplicationModel } from './application_model.js';

export class Settings extends ApplicationModel {
  static tableName = 'key-val';
  static primaryKey = 'key'
  static externalId = true;
  static attributes = this.attrAccessor('key', 'fastingGoal', 'eatingGoal', 'statsBeginsAt')

  static defaultValues = {
    fastingGoal: 16,
    eatingGoal: 8
  }

  get planHuman() {
    return `${this.fastingGoal}/${this.eatingGoal}`;
  }

  get fastingGoalInMs() {
    return this.fastingGoal * 60 * 60 * 1000;
  }

  get eatingGoalInMs() {
    return this.eatingGoal * 60 * 60 * 1000;
  }
}


window.Settings = Settings;
